import { ShoppingOutlined } from '@ant-design/icons';

import { lazyRouteComponent } from '@tanstack/react-router';

import { ACCOUNT_ROLE_CODES } from '@lib/types';

import { Route } from '@lib/types/route';

import { ROUTE_PATHS } from '../route-paths';

const StoreProductsPage = lazyRouteComponent(
  () => import('./pages/store-products'),
);

const ProductDetailsPage = lazyRouteComponent(() => import('./pages/details'));

const AdminProductsPage = lazyRouteComponent(() => import('./pages/admin'));

export const getRoutes = (): Route[] => [
  {
    page: AdminProductsPage,
    path: ROUTE_PATHS.ADMIN_PRODUCTS,
    title: 'Produtos',
    icon: ShoppingOutlined,
    adminSection: 'operation',
    adminOrder: 25,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
  },
  {
    page: ProductDetailsPage,
    path: ROUTE_PATHS.STORE_PRODUCT_DETAILS,
    title: 'Detalhes do produto',
    hidden: true,
    public: true,
  },
  {
    page: StoreProductsPage,
    path: ROUTE_PATHS.STORE_PRODUCTS,
    title: 'Produtos da loja',
    hidden: true,
    public: true,
  },
];
